const validate = values => {
    const errors = {fecha: '', periodo: '', filtro: ''};
    if (values.filtro && values.filtro.value === 'periodo') {
        if (!values.periodo) {
            errors.periodo = 'Seleccione un periodo';
        }
    } else if (values.filtro && values.filtro.value === 'fecha') {
        if (!values.fecha) {
            errors.fecha = 'Seleccione una fecha';
        }
    } else {
        errors.filtro = 'Seleccione un filtro';
    }
    return errors;
};

export default validate;


// WEBPACK FOOTER //
// ./src/components/pages/celulares/zonas/validate.ts